import { computed } from 'vue'
import { useStore } from 'vuex'

export function checkMaxWindowWidth(maxWidth: number, currentWidth: number) {
  return currentWidth <= maxWidth
}

export function useScreenMix() {
  const store = useStore()

  const globalsWindowSize = computed(() => store.getters.globals_window_size)

  return {
    globalsWindowSize,
    mobile: computed(() => store.getters.globals_mobile),
    max1280: computed(() => checkMaxWindowWidth(1280, globalsWindowSize.value.width)),
    max768: computed(() => checkMaxWindowWidth(768, globalsWindowSize.value.width)),
    max620: computed(() => checkMaxWindowWidth(620, globalsWindowSize.value.width)),
    max540: computed(() => checkMaxWindowWidth(540, globalsWindowSize.value.width)),
  }
}
